import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useTranslation } from "@crehana/i18n";
import ArrowBottom from "@crehana/icons/ArrowBottom";
import { useCollapse } from "@crehana/react-hooks";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { Col } from "@crehana/ui";
import cn from "clsx";
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import styled from "styled-components";
import { MAIN_FOOTER_PAGE_KEY } from "../constants";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ArrowBottomStyled = /*#__PURE__*/styled(ArrowBottom).withConfig({
  componentId: "sc-zxy7f4-0"
})(["\n  transition: transform 350ms ease-in-out;\n  &.open {\n    transform: rotate(180deg);\n  }\n"]);
var isExternalLink = function isExternalLink(link) {
  return link.includes('http://') || link.includes('https://');
};
var Mobile = function Mobile(_ref) {
  var title = _ref.title,
    links = _ref.links;
  var _useTranslation = useTranslation(MAIN_FOOTER_PAGE_KEY),
    t = _useTranslation.t;
  var _useCollapse = useCollapse({
      defaultOpen: false
    }),
    getCollapseProps = _useCollapse.getCollapseProps,
    getToggleProps = _useCollapse.getToggleProps,
    isOpen = _useCollapse.isOpen;
  return /*#__PURE__*/_jsxs("div", {
    className: "sm:hidden",
    children: [/*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
      type: "button",
      className: "w-full mb-20 font-button"
    }, getToggleProps()), {}, {
      children: /*#__PURE__*/_jsxs("span", {
        className: "flex justify-between",
        children: [t(title), /*#__PURE__*/_jsx(ArrowBottomStyled, {
          size: 16,
          ignoreColor: true,
          className: cn('fill-current text-base-lighter', isOpen && 'open')
        })]
      })
    })), /*#__PURE__*/_jsx("ul", _objectSpread(_objectSpread({
      className: isOpen ? 'mb-16' : undefined
    }, getCollapseProps()), {}, {
      children: links.map(function (l) {
        var anchorProps = _objectSpread({
          href: l.href,
          className: 'transition-all font-subtitle4 text-inherit hover:text-secondary-light'
        }, isExternalLink(l.href) ? {
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {});
        return /*#__PURE__*/_jsx("li", {
          className: "pb-16",
          children: l.renderLabelAsHtml ? /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, anchorProps), {}, {
            dangerouslySetInnerHTML: {
              __html: t(l.label)
            }
          })) : /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, anchorProps), {}, {
            children: t(l.label)
          }))
        }, l.label || l.href);
      })
    }))]
  });
};
var Desktop = function Desktop(_ref2) {
  var title = _ref2.title,
    links = _ref2.links;
  var _useTranslation2 = useTranslation(MAIN_FOOTER_PAGE_KEY),
    t = _useTranslation2.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "hidden sm:block",
    children: [/*#__PURE__*/_jsx("span", {
      className: "block mb-20 font-button",
      children: t(title)
    }), /*#__PURE__*/_jsx("ul", {
      children: links.map(function (l) {
        var anchorProps = _objectSpread({
          href: l.href,
          className: 'transition-all font-subtitle4 text-inherit hover:text-secondary-light'
        }, isExternalLink(l.href) ? {
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {});
        return /*#__PURE__*/_jsx("li", {
          className: "pb-16",
          children: l.renderLabelAsHtml ? /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, anchorProps), {}, {
            dangerouslySetInnerHTML: {
              __html: t(l.label)
            }
          })) : /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, anchorProps), {}, {
            children: t(l.label)
          }))
        }, l.label || l.href);
      })
    })]
  });
};
var LinksColumn = function LinksColumn(_ref3) {
  var title = _ref3.title,
    links = _ref3.links,
    isDark = _ref3.isDark;
  return /*#__PURE__*/_jsxs(Col, {
    xs: 10,
    sm: 4,
    md: 2,
    offset: {
      xs: 1,
      sm: 0
    },
    nowrap: true,
    className: "sm:flex flex-col items-center md:block ".concat(isDark ? 'text-base-lighter' : 'text-base-dark'),
    children: [/*#__PURE__*/_jsx(Mobile, {
      title: title,
      links: links
    }), /*#__PURE__*/_jsx(Desktop, {
      title: title,
      links: links
    })]
  });
};
export default LinksColumn;